import React, { InputHTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './InputField.module.scss';

type InputFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  small?: boolean;
};

const InputField = ({
  small,
  ...props
}: React.PropsWithChildren<InputFieldProps>) => (
  <input
    {...props}
    className={clsx(styles.InputField, small && styles.small)}
  />
);

export default InputField;
